/* ==========================================================================
   GL Silver Studio — theme.js
   No dependencies. Everything degrades gracefully without JS.
   ========================================================================== */
(function () {
  'use strict';

  var on = function (el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts); };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------ toast   */
  var toastTimer;
  function toast(message) {
    var root = document.getElementById('ToastRoot');
    if (!root) return;
    root.textContent = message;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      root.classList.remove('is-visible');
      setTimeout(function () { root.hidden = true; }, 300);
    }, 2600);
  }

  /* ------------------------------------------------------ mobile drawer */
  function initDrawer() {
    var drawer = $('[data-drawer]');
    var overlay = $('[data-drawer-overlay]');
    if (!drawer) return;

    function open() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      drawer.setAttribute('aria-hidden', 'false');
    }
    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      drawer.setAttribute('aria-hidden', 'true');
    }

    $$('[data-drawer-open]').forEach(function (b) { on(b, 'click', open); });
    $$('[data-drawer-close]').forEach(function (b) { on(b, 'click', close); });
    on(overlay, 'click', close);
    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ------------------------------------------------------- search panel */
  /* One search experience for the whole store. The header icon and the field
     at the top of the menu both open this. Results come from Shopify's own
     predictive search, rendered through sections/search-ajax.liquid so prices
     and images arrive already formatted.

     Without JS the icon is still a plain link to /search, so nothing is lost. */
  function initSearchPanel() {
    var panel = $('[data-search-panel]');
    if (!panel || panel.dataset.bound) return;
    panel.dataset.bound = '1';

    var input   = $('[data-search-input]', panel);
    var results = $('[data-search-results]', panel);
    var idle    = $('[data-search-idle]', panel);
    var clear   = $('[data-search-clear]', panel);
    var timer, lastAsked = '', controller;

    function open(e) {
      if (e) e.preventDefault();
      // close the menu first if the tap came from inside it
      var drawer = $('[data-drawer]');
      if (drawer && drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        var ov = $('[data-drawer-overlay]');
        if (ov) ov.classList.remove('is-open');
      }
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      // a beat, so the panel is on screen before the keyboard comes up
      setTimeout(function () { if (input) input.focus(); }, 90);
    }

    function close() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (input) input.blur();
    }

    function render(html) {
      if (!results) return;
      results.innerHTML = html;
      var got = html.trim().length > 0;
      if (idle) idle.hidden = got;
    }

    function ask(term) {
      if (term === lastAsked) return;
      lastAsked = term;

      if (term.length < 2) {
        render('');
        return;
      }

      panel.classList.add('is-busy');
      if (controller && controller.abort) controller.abort();
      controller = window.AbortController ? new AbortController() : null;

      fetch('/search/suggest?q=' + encodeURIComponent(term) +
            '&resources[type]=product,collection' +
            '&resources[limit]=6' +
            '&section_id=search-ajax',
            controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { render(unwrapSection(html)); })
        .catch(function () { /* aborted or offline — leave what is on screen */ })
        .finally(function () { panel.classList.remove('is-busy'); });
    }

    $$('[data-search-open]').forEach(function (b) { on(b, 'click', open); });
    $$('[data-search-close]').forEach(function (b) { on(b, 'click', close); });

    /* The header bar cycles through the popular terms, so the bar itself
       suggests what there is to look for. */
    var rotor = $('[data-search-rotate]');
    var host = rotor && rotor.closest('[data-rotate]');
    if (rotor && host) {
      var words = (host.dataset.rotate || '').split(',')
        .map(function (w) { return w.trim(); })
        .filter(Boolean);

      if (words.length > 1) {
        var i = 0;
        setInterval(function () {
          if (panel.classList.contains('is-open')) return;
          i = (i + 1) % words.length;
          rotor.style.opacity = '0';
          setTimeout(function () {
            rotor.textContent = 'Search for ' + words[i].toLowerCase();
            rotor.style.opacity = '';
          }, 220);
        }, 2800);
      }
    }

    on(input, 'input', function () {
      var term = input.value.trim();
      if (clear) clear.hidden = term.length === 0;
      clearTimeout(timer);
      timer = setTimeout(function () { ask(term); }, 220);
    });

    on(clear, 'click', function () {
      input.value = '';
      clear.hidden = true;
      lastAsked = '';
      render('');
      input.focus();
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    });
  }

  /* ------------------------------------------------------------- share  */
  /* A web page cannot post to Instagram or WhatsApp by itself. What it can do
     is hand the link to the phone, which then offers every app installed —
     that is navigator.share, and it is what almost every shopper will get.

     Desktop browsers mostly have no share sheet, so those fall back to a row
     of ordinary links plus copy-to-clipboard. */
  function initShare() {
    $$('[data-share]').forEach(function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';

      var go = $('[data-share-go]', box);
      var list = $('[data-share-list]', box);
      var url = window.location.href.split('#')[0];
      var title = box.dataset.title || document.title;
      var text = box.dataset.text || title;
      var native = typeof navigator.share === 'function';

      // build the fallback links whether or not we end up showing them
      var eu = encodeURIComponent(url);
      var et = encodeURIComponent(text + ' — ' + title);
      var links = {
        whatsapp: 'https://wa.me/?text=' + encodeURIComponent(text + ' — ' + title + ' ' + url),
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + eu,
        x: 'https://twitter.com/intent/tweet?url=' + eu + '&text=' + et,
        pinterest: 'https://pinterest.com/pin/create/button/?url=' + eu + '&description=' + et,
        mail: 'mailto:?subject=' + et + '&body=' + eu
      };
      $$('[data-share-net]', box).forEach(function (a) {
        var href = links[a.dataset.shareNet];
        if (href) a.href = href;
      });

      /* Two presentations of the same thing. A row of icons sitting in the
         page can simply be shown when there is no share sheet. A dropdown
         hanging off an icon must stay shut until it is asked for, or it
         covers the photo the moment the page loads. */
      var isMenu = box.dataset.shareMode === 'menu';

      if (!native && list && !isMenu) list.hidden = false;

      on(go, 'click', function (e) {
        e.stopPropagation();
        if (native) {
          navigator.share({ title: title, text: text, url: url }).catch(function (err) {
            /* Closing the phone's share sheet rejects this promise exactly the
               same way a real failure does. Opening our own menu on top of
               that means the shopper dismisses one sheet and gets handed
               another — so a deliberate dismissal is left alone, and only a
               genuine failure falls back to the list. */
            var dismissed = err && (err.name === 'AbortError' || err.name === 'NotAllowedError');
            if (!dismissed && list) list.hidden = false;
          });
        } else if (list) {
          list.hidden = !list.hidden;
        }
      });

      if (isMenu) {
        on(document, 'click', function (e) {
          if (list && !list.hidden && !box.contains(e.target)) list.hidden = true;
        });
        on(document, 'keydown', function (e) {
          if (e.key === 'Escape' && list) list.hidden = true;
        });
      }

      on($('[data-share-copy]', box), 'click', function () {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () { toast('Link copied'); });
        } else {
          var t = document.createElement('textarea');
          t.value = url;
          document.body.appendChild(t);
          t.select();
          try { document.execCommand('copy'); toast('Link copied'); } catch (e) {}
          document.body.removeChild(t);
        }
      });
    });
  }

  /* -------------------------------------------------------- help bubble */
  function initHelpBubble() {
    var bub = $('[data-helpbub]');
    if (!bub || bub.dataset.bound) return;
    bub.dataset.bound = '1';

    var fab = $('[data-helpbub-toggle]', bub);
    var menu = $('[data-helpbub-menu]', bub);
    if (!fab || !menu) return;

    function set(open) {
      bub.classList.toggle('is-open', open);
      menu.hidden = !open;
      fab.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    on(fab, 'click', function () { set(menu.hidden); });
    on(document, 'click', function (e) { if (!bub.contains(e.target)) set(false); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* ---------------------------------------------------------- wishlist  */
  /* Kept in the browser, so it costs nothing and needs no app. The trade is
     that it does not follow a shopper to another device — which is the right
     trade at this size of catalogue.

     Only handles are stored. Every card is re-fetched from Shopify when the
     list is shown, so prices and stock are never stale and a piece that has
     been unpublished simply falls out of the list. */
  var WISH_KEY = 'gss:wish';

  function readWish() {
    try {
      var raw = JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
      return Array.isArray(raw) ? raw.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }

  function writeWish(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list.slice(0, 100))); } catch (e) {}
    paintWishCounts(list);
  }

  function paintWishCounts(list) {
    var n = (list || readWish()).length;
    $$('[data-wish-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    $$('[data-wish-total]').forEach(function (el) { el.textContent = n; });
  }

  /* Marks whichever hearts are on screen — including cards that arrived by
     fetch after the page had already loaded. */
  function paintWishHearts() {
    var list = readWish();
    $$('[data-wish-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.dataset.handle) > -1;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', (on ? 'Remove from wishlist: ' : 'Save: ') + (btn.dataset.title || ''));
    });
    // the little label beside the heart on a product page
    $$('[data-wish-tip]').forEach(function (tip) {
      var btn = tip.closest('[data-wish-toggle]');
      if (btn) tip.textContent = btn.classList.contains('is-on') ? 'Saved' : 'Save';
    });
  }

  /* The list itself never leaves the shopper's browser, so nothing about it
     reaches Shopify. What we can do is announce the moment — every ad and
     analytics pixel already on the page gets told, which is what turns the
     wishlist from a private convenience into something you can read.

     AddToWishlist is a standard Meta event and add_to_wishlist a standard GA4
     one, so both land in the normal reports with no setup. Each call is
     guarded: with no pixel installed, nothing happens and nothing breaks. */
  function trackWishAdd(btn) {
    var handle = btn.dataset.handle;
    var title = btn.dataset.title || handle;
    var price = parseFloat(btn.dataset.amount || '0') || 0;
    var kind = btn.dataset.type || '';
    var coll = btn.dataset.collection || '';

    try {
      if (window.fbq) {
        window.fbq('track', 'AddToWishlist', {
          content_ids: [handle],
          content_name: title,
          content_type: 'product',
          content_category: kind,
          value: price,
          currency: 'INR'
        });
      }
    } catch (e) {}

    /* Two shapes of the same fact, on purpose.

       The items array is what GA4's built-in ecommerce reporting understands.
       The flat wl_ parameters are what a custom dimension can be built from —
       GA4 cannot reach inside the items array for that. Sending both means the
       standard reports work AND you can chart top-wishlisted by collection. */
    var flat = {
      currency: 'INR',
      value: price,
      wl_product: title,
      wl_handle: handle,
      wl_category: kind,
      wl_collection: coll
    };

    try {
      if (window.gtag) {
        var payload = {};
        for (var k in flat) { payload[k] = flat[k]; }
        payload.items = [{
          item_id: handle, item_name: title,
          item_category: kind, item_category2: coll, price: price
        }];
        window.gtag('event', 'add_to_wishlist', payload);
      }
    } catch (e) {}

    try {
      if (window.dataLayer && window.dataLayer.push) {
        var dl = { event: 'add_to_wishlist' };
        for (var j in flat) { dl[j] = flat[j]; }
        window.dataLayer.push(dl);
      }
    } catch (e) {}

    /* Shopify's newer pixels — the ones the Facebook and Google sales channels
       install — run sandboxed, where a direct fbq or gtag call cannot reach
       them. This is the sanctioned way in: publish the event and any connected
       pixel can subscribe to it. Covers both old and new setups. */
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish('wishlist_add', {
          handle: handle, title: title, category: kind,
          collection: coll, price: price, currency: 'INR'
        });
      }
    } catch (e) {}
  }

  /* --------------------------------------------------- card click track */
  /* Which piece got tapped, and out of which row.

     Shopify's own Google and Facebook channels report views, add-to-carts and
     purchases, so those are left alone — sending them twice would double every
     number. What no channel reports is the click on a card in a list, which is
     the one that answers "which row is actually earning its place on the home
     page". select_item is the standard GA4 event for exactly that.

     Delegated from the document so cards fetched in later — recently viewed,
     recommendations, the wishlist page — are covered without re-binding. */
  function initCardTracking() {
    if (document.body.dataset.cardTrack) return;
    document.body.dataset.cardTrack = '1';

    on(document, 'click', function (e) {
      if (!e.target.closest) return;
      var link = e.target.closest('.card a[href]');
      if (!link) return;

      var card = link.closest('[data-card]');
      if (!card) return;

      // the heading above whichever row this card is sitting in
      var listName = '';
      var host = card.closest('.section') || card.closest('.foryou__row');
      if (host) {
        var head = host.querySelector('.section-head h2, .section-head h1, h1, h2');
        if (head) listName = head.textContent.trim();
      }
      if (!listName) listName = document.title;

      // position within its own grid, so row order can be judged
      var index = 0;
      var grid = card.parentElement;
      if (grid) index = Array.prototype.indexOf.call(grid.children, card) + 1;

      var price = parseFloat(card.dataset.amount || '0') || 0;
      var coll = card.dataset.collection || '';
      var item = {
        item_id: card.dataset.handle,
        item_name: card.dataset.title || card.dataset.handle,
        item_category: card.dataset.type || '',
        item_category2: coll,
        item_list_name: listName,
        index: index,
        price: price
      };

      // flat copies, for the same custom-dimension reason as the wishlist
      var flat = {
        item_list_name: listName,
        cc_product: item.item_name,
        cc_handle: item.item_id,
        cc_category: item.item_category,
        cc_collection: coll,
        cc_position: index
      };

      try {
        if (window.gtag) {
          var payload = {};
          for (var k in flat) { payload[k] = flat[k]; }
          payload.items = [item];
          window.gtag('event', 'select_item', payload);
        }
      } catch (err) {}

      try {
        if (window.dataLayer && window.dataLayer.push) {
          var dl = { event: 'select_item' };
          for (var j in flat) { dl[j] = flat[j]; }
          window.dataLayer.push(dl);
        }
      } catch (err) {}

      try {
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish('product_card_click', {
            handle: item.item_id, title: item.item_name,
            category: item.item_category, collection: coll,
            list: listName, position: index, price: price
          });
        }
      } catch (err) {}
    });
  }

  function initWishlist() {
    paintWishCounts();
    paintWishHearts();

    $$('[data-wish-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';

      on(btn, 'click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var handle = btn.dataset.handle;
        if (!handle) return;

        var list = readWish();
        var at = list.indexOf(handle);

        if (at > -1) {
          list.splice(at, 1);
          toast('Removed from wishlist');
        } else {
          list.unshift(handle);
          toast('Saved to wishlist');
          trackWishAdd(btn);
        }

        writeWish(list);
        paintWishHearts();

        // on the wishlist page itself, drop the card straight out of the grid
        var page = $('[data-wishlist]');
        if (page && at > -1) {
          var card = btn.closest('.card');
          if (card) {
            card.style.opacity = '0';
            setTimeout(function () { card.remove(); renderWishlist(true); }, 220);
          }
        }
      });
    });
  }

  /* Builds the wishlist page. `quiet` skips the loading line when we are only
     re-checking after a removal. */
  function renderWishlist(quiet) {
    var root = $('[data-wishlist]');
    if (!root) return;

    var grid    = $('[data-wish-grid]', root);
    var empty   = $('[data-wish-empty]', root);
    var foot    = $('[data-wish-foot]', root);
    var loading = $('[data-wish-loading]', root);
    var summary = $('[data-wish-summary]', root);
    var list    = readWish();

    function settle(count) {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = count > 0;
      if (foot) foot.hidden = count === 0;
      if (grid) grid.hidden = count === 0;
      if (summary) {
        summary.hidden = count === 0;
        summary.textContent = count + (count === 1 ? ' piece saved' : ' pieces saved');
      }
    }

    if (!list.length) { settle(0); return; }
    if (loading) loading.hidden = !!quiet;

    Promise.all(list.map(function (h) {
      return getHTML('/products/' + encodeURIComponent(h) + '?section_id=card-ajax');
    })).then(function (parts) {
      var html = parts.map(unwrapSection).filter(function (s) { return s.trim(); });

      // anything that failed to come back is gone from the shop — forget it
      if (html.length !== list.length) {
        var kept = list.filter(function (h, i) { return parts[i] && unwrapSection(parts[i]).trim(); });
        writeWish(kept);
      }

      if (grid) grid.innerHTML = html.join('');
      settle(html.length);

      initAddToCart();
      initNotify();
      initWishlist();
      initMotion();
      initReveal();
    });
  }

  function initWishlistPage() {
    var root = $('[data-wishlist]');
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';

    on($('[data-wish-clear]', root), 'click', function () {
      writeWish([]);
      paintWishHearts();
      renderWishlist(true);
      toast('Wishlist cleared');
    });

    renderWishlist();
  }

  /* ------------------------------------------------------------ footer  */
  /* The columns are marked open in the Liquid so that with JS off, or on a
     desktop, every link is there. On a phone they collapse — the footer goes
     from a screen and a half of links to a short list of headings. */
  function initFooterFold() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    $$('.footer__col').forEach(function (d) { d.open = false; });
  }

  /* ------------------------------------------------------------ facets  */
  /* On a phone the filter column becomes a sheet. Above 990px the CSS keeps
     it as a plain sidebar and none of this has any visible effect. */
  function initFacets() {
    var aside = $('[data-facets]');
    if (!aside || aside.dataset.bound) return;
    aside.dataset.bound = '1';

    var scrim = $('.facets__scrim');

    function open() {
      aside.classList.add('is-open');
      if (scrim) scrim.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      aside.classList.remove('is-open');
      if (scrim) scrim.hidden = true;
      document.body.style.overflow = '';
    }

    $$('[data-facets-open]').forEach(function (b) { on(b, 'click', open); });
    $$('[data-facets-close]').forEach(function (b) { on(b, 'click', close); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && aside.classList.contains('is-open')) close();
    });
  }

  /* ----------------------------------------------------------- gallery  */
  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      if (gallery.dataset.bound) return;      // boot() re-runs in the editor
      gallery.dataset.bound = '1';

      var slides = $$('[data-gallery-slide]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      var dots   = $$('[data-gallery-dot]', gallery);
      if (!slides.length) return;

      var at = 0;

      function show(index) {
        at = Math.max(0, Math.min(slides.length - 1, index));
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === at); });
        [thumbs, dots].forEach(function (list) {
          list.forEach(function (t, i) {
            t.classList.toggle('is-active', i === at);
            t.setAttribute('aria-current', i === at ? 'true' : 'false');
          });
        });
      }

      thumbs.forEach(function (t, i) { on(t, 'click', function () { show(i); }); });
      dots.forEach(function (d, i) { on(d, 'click', function () { show(i); }); });

      /* Swipe. On a phone this is how people move through photos — the
         thumbnail strip is a desktop habit. Only a clearly horizontal drag
         counts, so scrolling the page down never changes the picture. */
      var stage = $('[data-zoom]', gallery);
      if (stage && slides.length > 1) {
        var x0 = 0, y0 = 0, tracking = false;

        on(stage, 'touchstart', function (e) {
          var t = e.changedTouches[0];
          x0 = t.clientX; y0 = t.clientY; tracking = true;
        }, { passive: true });

        on(stage, 'touchend', function (e) {
          if (!tracking) return;
          tracking = false;
          var t = e.changedTouches[0];
          var dx = t.clientX - x0;
          var dy = t.clientY - y0;
          if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
          show(dx < 0 ? at + 1 : at - 1);
        }, { passive: true });
      }

      // jump the stage to whichever image belongs to a newly selected variant
      on(gallery, 'variant:image', function (e) {
        var mediaId = e.detail && e.detail.mediaId;
        if (!mediaId) return;
        var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
        if (idx > -1) show(idx);
      });

      show(0);
    });
  }

  /* ----------------------------------------------------- magnifier lens  */
  /* A framed square follows the cursor and paints the patch of photo beneath
     it at ZOOM magnification. The underlying image never moves.            */
  function initZoom() {
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!canHover) return;   // touch devices get the lightbox instead

    $$('[data-zoom]').forEach(function (stage) {
      var lens = document.createElement('span');
      lens.className = 'zoom-lens';
      stage.appendChild(lens);

      var ZOOM = parseFloat(stage.dataset.zoom) || 2.6;

      function activeImage() {
        return stage.querySelector('img.is-active') || stage.querySelector('img');
      }

      on(stage, 'mouseenter', function () {
        var im = activeImage();
        if (!im) return;
        lens.style.backgroundImage = 'url("' + (im.currentSrc || im.src) + '")';
        stage.classList.add('is-zoom');
      });

      on(stage, 'mouseleave', function () {
        stage.classList.remove('is-zoom');
      });

      on(stage, 'mousemove', function (e) {
        if (!activeImage()) return;

        var r = stage.getBoundingClientRect();
        var lw = lens.offsetWidth;
        var lh = lens.offsetHeight;

        // centre the lens on the cursor, then keep it fully inside the frame
        var lx = Math.max(0, Math.min(r.width - lw, (e.clientX - r.left) - lw / 2));
        var ly = Math.max(0, Math.min(r.height - lh, (e.clientY - r.top) - lh / 2));

        lens.style.left = lx + 'px';
        lens.style.top = ly + 'px';
        lens.style.backgroundSize = (r.width * ZOOM) + 'px ' + (r.height * ZOOM) + 'px';
        lens.style.backgroundPosition = (-lx * ZOOM) + 'px ' + (-ly * ZOOM) + 'px';
      });
    });
  }

  /* ------------------------------------------------------------ lightbox */
  function initLightbox() {
    var box = $('[data-lightbox]');
    if (!box) return;
    var img = $('[data-lightbox-image]', box);

    function open(src, alt) {
      if (!src) return;
      img.src = src;
      img.alt = alt || '';
      box.classList.add('is-open');
      box.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      box.classList.remove('is-open');
      box.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    $$('[data-lightbox-open]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var stage = btn.closest('[data-zoom]') || document;
        var active = stage.querySelector('img.is-active') || stage.querySelector('img');
        if (active) open(active.currentSrc || active.src, active.alt);
      });
    });

    $$('[data-lightbox-close]').forEach(function (b) { on(b, 'click', close); });
    on(box, 'click', function (e) { if (e.target === box) close(); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* --------------------------------------------------------- quantity   */
  function initQuantity() {
    $$('[data-qty]').forEach(function (wrap) {
      var input = $('input', wrap);
      if (!input) return;
      $$('[data-qty-step]', wrap).forEach(function (btn) {
        on(btn, 'click', function () {
          var step = parseInt(btn.dataset.qtyStep, 10) || 1;
          var min = parseInt(input.min, 10) || 1;
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = next < min ? min : next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------------------------------------------------- variant picker  */
  function initVariants() {
    $$('[data-product-root]').forEach(function (root) {
      var dataEl = $('[data-variant-json]', root);
      var form = $('[data-product-form]', root);
      if (!dataEl || !form) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
      if (!variants || !variants.length) return;

      var idInput = $('[data-variant-id]', form);
      var priceEls = $$('[data-price]', root); // main price + sticky bar
      var comparEl = $('[data-compare]', root);
      var saveEl = $('[data-save]', root);
      var skuEl = $('[data-sku]', root);
      var stockEl = $('[data-stock]', root);
      var submitEl = $('[data-add]', root);
      var gallery = $('[data-gallery]', root);
      var moneyFormat = root.dataset.moneyFormat || '₹{{amount}}';

      function formatMoney(cents) {
        var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
        var parts = amount.split('.');
        // Indian grouping: last 3 digits, then pairs
        var intPart = parts[0];
        var last3 = intPart.slice(-3);
        var rest = intPart.slice(0, -3);
        if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
        return '₹' + last3 + (parts[1] ? '.' + parts[1] : '');
      }

      // The option radios live outside <form> (linked by the form= attribute),
      // so they must be queried from the product root, not the form.
      function selectedOptions() {
        return $$('[data-option-index]', root)
          .filter(function (i) { return i.checked; })
          .sort(function (a, b) { return a.dataset.optionIndex - b.dataset.optionIndex; })
          .map(function (i) { return i.value; });
      }

      function findVariant(opts) {
        return variants.find(function (v) {
          return opts.every(function (val, i) { return v.options[i] === val; });
        });
      }

      function refreshAvailability(opts) {
        // For each option input, check whether at least one variant with that
        // value (holding earlier selections fixed) is purchasable.
        $$('[data-option-index]', root).forEach(function (input) {
          var idx = parseInt(input.dataset.optionIndex, 10);
          var trial = opts.slice();
          trial[idx] = input.value;
          var possible = variants.some(function (v) {
            for (var i = 0; i <= idx; i++) {
              if (trial[i] !== undefined && v.options[i] !== trial[i]) return false;
            }
            return v.available;
          });
          input.disabled = !possible;
        });
      }

      function update() {
        var opts = selectedOptions();
        var variant = findVariant(opts);

        $$('[data-option-selected]', root).forEach(function (el) {
          var idx = parseInt(el.dataset.optionSelected, 10);
          if (opts[idx]) el.textContent = opts[idx];
        });

        refreshAvailability(opts);

        if (!variant) {
          if (submitEl) { submitEl.disabled = true; submitEl.textContent = 'Unavailable'; }
          return;
        }

        if (idInput) idInput.value = variant.id;

        priceEls.forEach(function (el) { el.textContent = formatMoney(variant.price); });
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (comparEl) {
          if (onSale) {
            comparEl.textContent = formatMoney(variant.compare_at_price);
            comparEl.hidden = false;
          } else {
            comparEl.hidden = true;
          }
        }
        if (saveEl) {
          if (onSale) {
            saveEl.textContent = formatMoney(variant.compare_at_price - variant.price) + ' off';
            saveEl.hidden = false;
          } else {
            saveEl.hidden = true;
          }
        }
        if (skuEl) skuEl.textContent = variant.sku || '—';

        if (stockEl) {
          stockEl.className = 'stock' + (variant.available
            ? (variant.inventory_management ? '' : ' stock--made')
            : ' stock--out');
          stockEl.textContent = variant.available
            ? (variant.inventory_management ? 'In stock — ships in 2–3 days' : 'Made to order — ships in 7–10 days')
            : 'Sold out';
        }

        if (submitEl) {
          submitEl.disabled = !variant.available;
          submitEl.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }

        if (gallery && variant.featured_media_id) {
          gallery.dispatchEvent(new CustomEvent('variant:image', {
            detail: { mediaId: variant.featured_media_id }
          }));
        }

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }
      }

      $$('[data-option-index]', root).forEach(function (input) {
        on(input, 'change', update);
      });

      update();
    });
  }

  /* --------------------------------------------------- add to cart ajax */
  function initAddToCart() {
    $$('[data-product-form]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      on(form, 'submit', function (e) {
        if (!window.fetch) return; // let the browser post normally
        e.preventDefault();

        var button = $('[data-add]', form);
        var original = button ? button.textContent : '';
        if (button) { button.disabled = true; button.textContent = 'Adding…'; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: form.querySelector('[data-variant-id]').value,
            quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) throw new Error(data.description || data.message);
            toast((data.product_title || 'Item') + ' added to cart');
            return fetch('/cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            $$('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.hidden = cart.item_count === 0;
            });
            // the drawer shows the number even when it is nought
            $$('[data-cart-total]').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          })
          .catch(function (err) { toast(err.message || 'Could not add to cart'); })
          .finally(function () {
            if (button) { button.disabled = false; button.textContent = original; }
          });
      });
    });
  }

  /* -------------------------------------------------------- cart page   */
  function initCartPage() {
    $$('[data-cart-qty]').forEach(function (input) {
      on(input, 'change', function () {
        var form = input.closest('form');
        if (form) form.submit();
      });
    });
  }

  /* ------------------------------------------------ copy discount code  */
  function initCopyCode() {
    $$('[data-copy]').forEach(function (btn) {
      on(btn, 'click', function () {
        var code = btn.dataset.copy || '';
        var done = function () { toast('Code ' + code + ' copied'); };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(fallback);
        } else {
          fallback();
        }

        function fallback() {
          var tmp = document.createElement('textarea');
          tmp.value = code;
          tmp.setAttribute('readonly', '');
          tmp.style.position = 'fixed';
          tmp.style.opacity = '0';
          document.body.appendChild(tmp);
          tmp.select();
          try { document.execCommand('copy'); done(); } catch (e) { toast('Code: ' + code); }
          document.body.removeChild(tmp);
        }
      });
    });
  }

  /* ------------------------------------------------- sticky buy bar     */
  function initBuyBar() {
    var bar = $('[data-buybar]');
    var anchor = $('[data-add]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    // Show the bar only once the real Add to cart button has scrolled away.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
    }, { rootMargin: '-90px 0px 0px 0px' });

    io.observe(anchor);
  }

  /* ---------------------------------------------------- scroll reveal   */
  /* ------------------------------------------------------------ motion  */
  /* One reveal system for the whole store, applied from here rather than by
     hand in thirteen section files — so every row of the page moves the same
     way and a new section inherits it for free.

     Children of a grid are given an index, so a row of cards arrives one after
     another instead of all at once. That stagger is what separates a page that
     animates from a page that feels considered.

     Anyone who has asked their device to reduce motion gets the finished state
     immediately, with nothing hidden and nothing moving. */
  var motionIO = null;

  var MOTION_GROUPS = [
    '.product-grid', '.col-grid', '.circles', '.quotes', '.offerstrip',
    '.trust__grid', '.mosaic', '.assurance', '.subnav__rail', '.acct__stats'
  ];
  var MOTION_SOLO = [
    '.section-head', '.split__text', '.split__media', '.duo__card',
    '.spotlight__card', '.foryou__row', '.acct__panel', '.wish__empty'
  ];

  function initMotion() {
    var fresh = [];

    MOTION_GROUPS.forEach(function (sel) {
      $$(sel).forEach(function (parent) {
        Array.prototype.forEach.call(parent.children, function (child, i) {
          if (child.classList.contains('anim')) return;
          child.classList.add('anim');
          // cap the stagger so a long grid never waits half a second to finish
          child.style.setProperty('--i', Math.min(i, 7));
          fresh.push(child);
        });
      });
    });

    MOTION_SOLO.forEach(function (sel) {
      $$(sel).forEach(function (el) {
        if (el.classList.contains('anim')) return;
        el.classList.add('anim');
        fresh.push(el);
      });
    });

    if (!fresh.length) return;

    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      fresh.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    /* Everything here starts at opacity 0, so a failure anywhere in this block
       would leave the page blank. If anything at all goes wrong, show it. */
    try {
      if (!motionIO) {
        motionIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            e.target.classList.add('is-in');
            motionIO.unobserve(e.target);
          });
        }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
      }
      fresh.forEach(function (el) { motionIO.observe(el); });
    } catch (e) {
      fresh.forEach(function (el) { el.classList.add('is-in'); });
    }
  }

  function initReveal() {
    var items = $$('[data-reveal]');
    if (!items.length) return;

    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    items.forEach(function (el) { io.observe(el); });
  }

  /* --------------------------------------------- delivery estimate      */
  /* Zone table lives in the theme settings — no courier API, so the number
     shown is an estimate and is labelled as one. */
  function initDelivery() {
    $$('[data-deliv]').forEach(function (box) {
      var input = $('[data-deliv-pin]', box);
      var go = $('[data-deliv-go]', box);
      var out = $('[data-deliv-out]', box);
      if (!input || !go || !out) return;

      // "110,120,201 = 2-4" per line  ->  { '110': [2,4], ... }
      var zones = {};
      (box.dataset.rules || '').split(/\r?\n/).forEach(function (line) {
        var bits = line.split('=');
        if (bits.length !== 2) return;
        var range = bits[1].trim().split('-');
        var lo = parseInt(range[0], 10);
        var hi = parseInt(range[1] || range[0], 10);
        if (isNaN(lo)) return;
        bits[0].split(',').forEach(function (p) {
          p = p.trim();
          if (p) zones[p] = [lo, isNaN(hi) ? lo : hi];
        });
      });

      var fallback = (box.dataset.default || '4-7').split('-');
      var making = parseInt(box.dataset.making, 10) || 0;

      function workingDaysFrom(days) {
        var d = new Date();
        var added = 0;
        while (added < days) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0) added++;      // skip Sundays
        }
        return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
      }

      function check() {
        var pin = (input.value || '').replace(/\D/g, '');
        out.classList.add('is-shown');

        if (pin.length !== 6) {
          out.classList.add('is-error');
          out.textContent = 'Please enter a valid 6-digit PIN code.';
          return;
        }

        var hit = zones[pin.slice(0, 3)];
        var lo = hit ? hit[0] : parseInt(fallback[0], 10) || 4;
        var hi = hit ? hit[1] : parseInt(fallback[1], 10) || 7;
        lo += making;
        hi += making;

        out.classList.remove('is-error');
        out.innerHTML = 'Delivery to <strong>' + pin + '</strong> by <strong>' +
          workingDaysFrom(lo) + ' – ' + workingDaysFrom(hi) + '</strong>' +
          (making ? ' <span class="muted">(includes ' + making + ' days making time)</span>' : '');
      }

      on(go, 'click', check);
      on(input, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); check(); } });
      on(input, 'input', function () {
        input.value = input.value.replace(/\D/g, '').slice(0, 6);
      });
    });
  }

  /* --------------------------------------------------------- modals     */
  var lastFocus = null;

  function openModal(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var first = el.querySelector('input, button');
    if (first) setTimeout(function () { first.focus(); }, 60);
  }

  function closeModal(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  function initModals() {
    $$('[data-modal-close]').forEach(function (btn) {
      on(btn, 'click', function () { closeModal(btn.closest('[data-modal]')); });
    });
    on(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('[data-modal].is-open').forEach(closeModal);
    });
  }

  /* ------------------------------------------------ notify me (sold out) */
  function initNotify() {
    var modal = document.getElementById('NotifyModal');
    if (!modal) return;

    var box = $('[data-notify-product]', modal);
    var img = $('[data-notify-image]', modal);
    var name = $('[data-notify-name]', modal);
    var sku = $('[data-notify-sku]', modal);
    var tags = $('[data-notify-tags]', modal);

    $$('[data-notify-open]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      on(btn, 'click', function (e) {
        e.preventDefault();
        var d = btn.dataset;

        if (box) {
          box.hidden = false;
          if (img) { img.src = d.image || ''; img.alt = d.title || ''; }
          if (name) name.textContent = d.title || '';
          if (sku) sku.textContent = d.sku ? 'SKU ' + d.sku : (d.type || '');
        }

        // Tag the customer so you can filter Customers by this piece later.
        if (tags) {
          var t = ['notify'];
          if (d.handle) t.push('notify:' + d.handle);
          if (d.type) t.push(d.type);
          tags.value = t.join(', ');
          tags.dataset.base = tags.value;
        }

        openModal(modal);
      });
    });
  }

  /* ------------------------------- carry the phone number into the tags  */
  /* Shopify's customer form has no phone field, so the number rides along
     as a tag (phone:9876543210) and stays filterable on the customer.     */
  function attachPhoneToTags(form, phoneSel, tagsSel) {
    var phone = $(phoneSel, form);
    var tags = $(tagsSel, form);
    if (!phone || !tags) return;
    on(form, 'submit', function () {
      var digits = (phone.value || '').replace(/[^\d+]/g, '');
      var base = tags.dataset.base || tags.value;
      tags.dataset.base = base;
      tags.value = digits ? base + ', phone:' + digits : base;
    });
  }

  function initPhoneCapture() {
    var nf = $('[data-notify-form]');
    if (nf) attachPhoneToTags(nf, '[data-notify-phone]', '[data-notify-tags]');
    var wf = $('[data-welcome-signup]');
    if (wf) attachPhoneToTags(wf, '[data-welcome-phone]', '[data-welcome-tags]');
  }

  /* ------------------------------------------------- welcome offer popup */
  var WELCOME_KEY = 'gss_welcome_seen';
  var WELCOME_PENDING = 'gss_welcome_pending';

  function initWelcome() {
    var modal = document.querySelector('[data-welcome]');
    if (!modal) return;

    var form = $('[data-welcome-form]', modal);
    var success = $('[data-welcome-success]', modal);
    var posted = window.location.search.indexOf('customer_posted=true') > -1;

    // Came back from a successful signup — show the code instead of the form.
    if (posted && safeGet(WELCOME_PENDING)) {
      safeSet(WELCOME_PENDING, '');
      safeSet(WELCOME_KEY, String(Date.now()));
      if (form) form.hidden = true;
      if (success) success.hidden = false;
      openModal(modal);
      return;
    }

    var signup = $('[data-welcome-signup]', modal);
    if (signup) on(signup, 'submit', function () { safeSet(WELCOME_PENDING, '1'); });

    var days = parseInt(modal.dataset.days, 10) || 30;
    var seen = parseInt(safeGet(WELCOME_KEY), 10);
    if (seen && (Date.now() - seen) < days * 86400000) return;

    var delay = (parseInt(modal.dataset.delay, 10) || 6) * 1000;
    setTimeout(function () {
      if (document.querySelector('[data-modal].is-open')) return; // never interrupt
      safeSet(WELCOME_KEY, String(Date.now()));
      openModal(modal);
    }, delay);
  }

  function safeGet(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function safeSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  /* --------------------------------------- feedback after a form posts   */
  function initPostedToast() {
    if (window.location.search.indexOf('customer_posted=true') === -1) return;
    if (safeGet(WELCOME_PENDING)) return;   // the welcome modal handles its own
    toast('Thank you — you are on the list.');
  }

  /* ------------------------------------------------------ facets/sort   */
  function initAutoSubmit() {
    $$('[data-auto-submit]').forEach(function (el) {
      on(el, 'change', function () {
        var form = el.closest('form');
        if (form) form.submit();
      });
    });
  }

  /* ---------------------------------------------- recently viewed / for you
     Personalisation without an app. Every product page a shopper opens is
     remembered on their device, newest first. The "For you" section then
     replays those pieces back, and asks Shopify for pieces that go with the
     last one they looked at.

     Stored on the device, not the account — Shopify gives a theme no way to
     write browsing history to a customer record, so a shopper who switches
     phone to laptop starts fresh there. Everything else works logged in or out.
  */
  var SEEN_KEY = 'gss:seen';
  var SEEN_MAX = 24;

  function readSeen() {
    try {
      var raw = JSON.parse(localStorage.getItem(SEEN_KEY) || '[]');
      return Array.isArray(raw) ? raw.filter(function (r) { return r && r.h; }) : [];
    } catch (e) { return []; }
  }

  function trackSeen() {
    var root = $('[data-product-root]');
    if (!root) return;
    var handle = root.dataset.handle;
    if (!handle) return;

    var list = readSeen().filter(function (r) { return r.h !== handle; });
    list.unshift({ h: handle, id: root.dataset.pid || '' });
    try {
      localStorage.setItem(SEEN_KEY, JSON.stringify(list.slice(0, SEEN_MAX)));
    } catch (e) { /* private mode — personalisation just stays off */ }
  }

  // Section Rendering API hands back the section wrapped in its own div.
  function unwrapSection(html) {
    if (!html) return '';
    var box = document.createElement('div');
    box.innerHTML = html.trim();
    var inner = box.firstElementChild;
    return inner && /^shopify-section/.test(inner.id || '') ? inner.innerHTML : box.innerHTML;
  }

  function getHTML(url) {
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
  }

  function fillRow(row, grid, html) {
    if (!row || !grid || !html.trim()) return false;
    grid.innerHTML = html;
    row.hidden = false;
    initAddToCart();
    initNotify();
    initWishlist();
    initMotion();
    initReveal();
    return true;
  }

  function initForYou() {
    var root = $('[data-foryou]');
    if (!root || !window.fetch) return;

    var limit = parseInt(root.dataset.limit, 10) || 5;
    var here = root.dataset.handle || '';
    var seen = readSeen();

    /* --- pieces that go with the last thing they opened ------------------ */
    var recsRow = $('[data-foryou-recs]', root);
    var anchor = root.dataset.pid || (seen[0] && seen[0].id) || '';
    if (recsRow && anchor) {
      getHTML('/recommendations/products?product_id=' + encodeURIComponent(anchor) +
              '&limit=' + limit + '&section_id=recs-ajax')
        .then(function (html) {
          fillRow(recsRow, $('[data-foryou-recs-grid]', root), unwrapSection(html));
        });
    }

    /* --- what they have already looked at -------------------------------- */
    var seenRow = $('[data-foryou-seen]', root);
    var queue = seen.filter(function (r) { return r.h !== here; }).slice(0, limit);
    if (seenRow && queue.length) {
      Promise.all(queue.map(function (r) {
        return getHTML('/products/' + encodeURIComponent(r.h) + '?section_id=card-ajax');
      })).then(function (parts) {
        fillRow(seenRow, $('[data-foryou-seen-grid]', root),
                parts.map(unwrapSection).join(''));
      });
    }
  }

  /* -------------------------------------------------------------- boot  */
  function boot() {
    initDrawer();
    initSearchPanel();
    initFooterFold();
    initFacets();
    initGallery();
    initZoom();
    initLightbox();
    initQuantity();
    initVariants();
    initAddToCart();
    initCartPage();
    initCopyCode();
    initBuyBar();
    initReveal();
    initMotion();
    initAutoSubmit();
    initDelivery();
    initModals();
    initNotify();
    initPhoneCapture();
    initWelcome();
    initPostedToast();
    trackSeen();
    initForYou();
    initCardTracking();
    initWishlist();
    initWishlistPage();
    initShare();
    initHelpBubble();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  /* Tapping back restores the previous page from the browser's cache without
     re-running any of this, so a heart saved on the product page would still
     look empty on the collection page behind it. Repaint on the way back. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { paintWishHearts(); paintWishCounts(); }
  });
})();
